import { makeStyles } from '@mui/styles';

export const accordionStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    color: '#004F9F',
    width: '100%',
    marginRight: 5
  },
  border: {
    borderRadius: 6,
    marginBottom: 4,
  },
  box: {
    width: '100%',
    display: 'flex',
  },
  bad: {
    background: 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgba(246,104,94,1) 100%)'
  },
  regular: {
    background: 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgba(246,255,169,1) 100%)'
  },
  good: {
    background: 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgb(165, 255, 168) 100%)'
  },
  iconG: {
    color: '#4caf50'
  },
  iconB: {
    color: '#f6685e'
  },
  text: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 4,
    marginRight: 20
  },
  scrollBox: {
    maxHeight: 400,
    overflowY: 'scroll'
  }
}));